export default {"src":"/_next/static/media/credit-card-cvc.673c534d.svg","height":21,"width":32,"blurWidth":0,"blurHeight":0};